/**
 * Annoteer brand mark — small indigo rounded square with the white "A"
 * letterform from the production manifest icon. Used in the SidePanel
 * and MeetingStage headers (and anywhere else we need the in-app
 * brand presence). Visually consistent with manifest/color.png so
 * users see the same glyph in the Teams app rail and in the app shell.
 */
export interface BrandMarkProps {
  /** Square size in pixels. Defaults to 20 (header sizing). */
  size?: number;
}

export function BrandMark({ size = 20 }: BrandMarkProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      role="img"
      aria-label="Annoteer"
      style={{ flexShrink: 0, display: 'block' }}
    >
      <rect width="24" height="24" rx="5" fill="#4F46E5" />
      <path
        d="M 7 18 L 12 6 L 17 18 M 9 14 L 15 14"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
